export default __webpack_public_path__ + "static/media/cookies_img.8afb0a74.png";